import { render, staticRenderFns } from "./GrayBarDeparturesPerMonth.vue?vue&type=template&id=b56ab9ba&"
import script from "./GrayBarDeparturesPerMonth.vue?vue&type=script&lang=js&"
export * from "./GrayBarDeparturesPerMonth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports